module.exports = __webpack_public_path__ + "img/icon_surprises_outlined.bb13c783.svg";